export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-Medium.9f1092d0.otf";